module.exports = __webpack_public_path__ + "static/media/secadmon_logo_gobierno_jal.bc5ec6c8.png";